<template>
  <div class="p-1 pt-2 pb-3">
    <div class="font-bold text-lg">
        Nhập số CMND/ CCCD
    </div>
    <div class="mt-2">
        <input inputmode="numeric" class="w-full h-14 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3 pt-1 pb-1 pr-3 color-main " @input="formatId" :class="{ 'border-input-success': checkId, 'border-input-error': start_check ? !checkId : false }" v-model="form.identity_card_manual" style="border: 2px solid #D6D9DB;" placeholder="CMND/ CCCD" />
        <div v-if="start_check ? !checkId : false" class="text-red-700 text-right">
            <span v-if="form.identity_card_manual.length < 1">
                CMND/CCCD không được để trống
            </span>
            <span v-else>
                CMND/CCCD không hợp lệ, vui lòng nhập lại
            </span>
        </div>
        <!-- <div v-if="click_check && phone_error ? form.phone.length < 1 ? true : false : false" class="text-right text-red-700">Số điện thoại không được để trống</div> -->
    </div>
    <div class="mt-4">
        <div  class="bg-color-vmain text-white  rounded-md text-center" style="background-color: #F1674A;">
            <button :disabled="loading_otp" @click="showResult" class="font-bold p-3 w-full" > <b-spinner v-if="loading_otp" small type="grow"></b-spinner> Tiếp tục</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['form', 'clickSend', 'loading_otp'],
    data() {
        return {
            start_check: false,
            checkId: false
        }
    },
    methods: {
        showResult(){
            this.formatId()
            if(this.checkId){
                this.loading_otp = true
                this.clickSend && this.clickSend()
            }
        },
        formatId(){
            this.start_check = true
            this.checkId = this.form.identity_card_manual ? this.form.identity_card_manual.length == 9 || this.form.identity_card_manual.length == 12 ? true : false : false
        },
    },
}
</script>

<style>
.bg-color-vmain {
    background-color: #F1674A;
}

.border-input-success {
    border: 2px solid #6aad6a !important;
    color: #6aad6a;
}
    
.border-input-error {
    border: 2px solid #dc2626 !important;
    color: #dc2626;
}
</style>